import { useState } from 'react';
import type { SavedAction } from '@/types';
import { Button, Modal, ModalClose, ModalContent, ModalTitle } from '@/components/ui';
import { MentionTextField } from './MentionTextField';

interface EditSavedTaskModalProps {
  action: SavedAction;
  onSave: (action: SavedAction) => void;
  onRemove: (id: string) => void;
  onClose: () => void;
}

export function EditSavedTaskModal({ action, onSave, onRemove, onClose }: EditSavedTaskModalProps) {
  const [template, setTemplate] = useState(action.template);

  return (
    <Modal open onOpenChange={(open) => !open && onClose()}>
      <ModalContent className="ui-modal ui-modal--task-editor">
        <div className="ui-modal__header">
          <ModalTitle className="ui-modal__title">Edit saved task</ModalTitle>
          <ModalClose className="ui-modal__close" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 16 16" fill="none" aria-hidden>
              <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </ModalClose>
        </div>

        <p className="ui-modal__helper">
          Use @user, @device, @access-group, or @schedule for parts that change
        </p>

        <div className="ui-modal__composer">
          <MentionTextField
            variant="modal"
            mentionMode="template"
            value={template}
            onChange={(val) => setTemplate(val)}
            focusOnMount
            aria-label="Task template"
          />
        </div>

        <div className="ui-modal__footer">
          <Button
            type="button"
            variant="tertiary"
            className="ui-modal__remove"
            onClick={() => onRemove(action.id)}
          >
            Remove task
          </Button>
          <div className="ui-modal__footer-right">
            <ModalClose asChild>
              <Button type="button" variant="secondary" size="lg">
                Cancel
              </Button>
            </ModalClose>
            <Button type="button" variant="primary" size="lg" onClick={() => onSave({ ...action, template })}>
              Save
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}
